<div
  class="hx-accordion-panel__header"
  role="button"
  [attr.aria-controls]="contentId"
  [attr.aria-disabled]="disabled || undefined"
  [attr.aria-expanded]="expanded"
  [attr.tabindex]="disabled ? -1 : 0"
  [class.hx-accordion-panel__header--label-large]="labelSize() === 'large'"
  [class.hx-accordion-panel__header--label-medium]="labelSize() === 'medium'"
  [class.hx-accordion-panel__header--label-small]="labelSize() === 'small'"
  [id]="headerId"
  (click)="onHeaderClick()">
  <div class="hx-accordion-panel__header-content">
    <ng-content select="[hxAccordionIcon]" />
    @if (headerIcon(); as icon) {
      <hx-icon aria-hidden="true" class="hx-accordion-panel__header-label-icon" [svgIcon]="icon" />
    }
    @if (parentAccordion?.showSectionNumbers()) {
      <span class="hx-accordion-panel__section-number">{{ panelIndex() + 1 }}.</span>
    }
    <ng-content select="[hxAccordionHeader]" />
    <div class="hx-accordion-panel__header-trailing">
      <ng-content select="[hxAccordionHeaderTrailing]" />
    </div>
    @if (!hideToggle()) {
      <hx-icon aria-hidden="true" class="hx-accordion-panel__icon" [svgIcon]="currentIconName()" />
    }
  </div>
</div>

@if (expanded) {
  <div class="hx-accordion-panel__content" role="region" [attr.aria-labelledby]="headerId" [id]="contentId">
    <div class="hx-accordion-panel__body">
      <ng-content select="[hxAccordionContent]" />
    </div>
  </div>
}
